module.exports = __webpack_public_path__ + "static/img/slogan.2f43221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogan.png
// module id = iMv4
// module chunks = 1